import React from 'react';
import styled from 'styled-components';

type IState = {
  error: Error | null;
};

// Without a boundary any render error unmounts the whole app to a white
// screen and unsaved work context is lost (e.g. the object-as-React-child
// crash from validation errors). Keeps the failure visible and recoverable.
export class ErrorBoundary extends React.Component<{}, IState> {
  state: IState = { error: null };

  static getDerivedStateFromError(error: Error): IState {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <Container>
          <h3>Something went wrong</h3>
          <Message>{this.state.error.message}</Message>
          <button onClick={() => window.location.reload()}>Reload</button>
        </Container>
      );
    }
    return this.props.children;
  }
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  gap: 8px;
`;

const Message = styled.pre`
  max-width: 80vw;
  white-space: pre-wrap;
  color: #b71c1c;
`;
